function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Price Tag Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M17.9791534,0.146446609 C18.1744155,0.341708755 18.1744155,0.658291245 17.9791534,0.853553391 L16.228,2.604 L16.9051768,7.00911246 C17.1233798,8.42630764 16.6533639,9.86194289 15.6395534,10.8757534 L8.58755339,17.9277534 C8.39228232,18.1230245 8.0756822,18.1230142 7.88042375,17.9277305 L0.146423755,10.1927305 C-0.0488168431,9.99746469 -0.0488066109,9.68089983 0.146446609,9.48564661 L7.19144661,2.44064661 C8.20949997,1.42259325 9.65165639,0.952536775 11.0742462,1.17520302 L15.544,1.874 L17.2720466,0.146446609 C17.4673088,-0.0488155365 17.7838912,-0.0488155365 17.9791534,0.146446609 Z M7.89855339,3.14775339 L1.20708393,9.83922285 L8.23402286,16.8670704 L14.9324466,10.1686466 C15.7210039,9.38008929 16.086541,8.2635784 15.9168093,7.16119687 L15.351,3.481 L13.3474045,5.4869484 C13.431267,5.81790243 13.343896,6.18321001 13.0855519,6.44155262 C12.694086,6.83501579 12.057114,6.83501579 11.6665466,6.44245339 C11.2752845,6.05119124 11.2752845,5.41660876 11.6665466,5.02534661 C11.9322312,4.75966197 12.3105725,4.67438918 12.6485726,4.76952824 L14.669,2.749 L10.9196805,2.16318553 C9.81264396,1.98991024 8.69071501,2.35559177 7.89855339,3.14775339 Z",
  id: "price-tag-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "price-tag-Icon/Global/pricetag",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "price-tag-Swatches/DarkGreen",
  transform: "translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "price-tag-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#price-tag-path-1"
})));

var SvgPriceTag = function SvgPriceTag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPriceTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/price-tag.5fad44b9.svg";
export { ForwardRef as ReactComponent };